// const map = ( number, generate ) => {
// 	const items = [];
// 	for ( let i = 0; i < number; i += 1 ) {
// 		items.push( generate() );
// 	}
// 	return items;
// };

// use like someArray.reduce( toObject );
// const toObject = ( object = {}, item, i ) => {
// 	const added = {};
// 	added[i] = item;

// 	return Object.assign( object, item );
// };
import { trim } from '@/lib/utils';

export const user = () => ( {
	name            : '',
	email           : '',
	permissionLevel : 1,
} );

export const job = () => ( {
	name     : '',
	summary  : '',
	number   : '',
	manager  : '',
	status   : 'Active', // should come from a db-defined set of options
	jobsType : {
		jobsTypesKey : '',
		description  : '',
	},
	fund : {
		description : '',
		fundsKey    : '',
	},
	firm : {
		description : '',
		firmsKey    : '',
	},
	facilities  : [],
	expenseType : '',
	tractNumber : '',
	projectFee  : '',
	fidCost     : '',
	location    : {
		description  : '',
		latitude     : null,
		longitude    : null,
		locationsKey : null,
	},
	locationDescription : '',
	dateCreated  	      : '',
	dateClosed   	      : '',
	dateStarted  	      : '',
	dateEnded    	      : '',
	pipeLength   	      : '',
	pipeDiameter 	      : '',
	pipeType     	      : {
		description  : null,
		pipeTypesKey : null,
	},
	fidEstimate    : '',
	devEstimate    : '',
	actionRequests : [],
	files          : [],
} );

export const editJob = ( editingJob ) => {
	const emptyJob = job();

	const { file, folder } = editingJob;

	return { file, folder, ...trim( emptyJob, editingJob ) };
};

export const facility = () => ( {
	name           : '',
	facilitiesType : {
		facilitiesTypesKey : '',
		description        : '',
	},
	number              : '',
	status              : '',
	owner               : '',
	purchasedFromFclc   : '',
	deeded              : '',
	locationDescription : '',
	normalFlow          : '',
	maxFlow             : '',
	comments            : '',
} );

export const editFacility = ( editingFacility ) => {
	const emptyFacility = facility();

	return trim( emptyFacility, editingFacility );
};

export const agreements = () => ( {
	gisReference      : '',
	facilities        : [],
	dateRecorded      : '',
	recordNumber      : '',
	recordOwner       : '',
	jobsKey           : '',
	wasteWater        : false,
	mappedInGis       : false,
	type              : '',
	agreementCategory : {
		agreementCategoriesKey : '',
		description            : '',
	},
	vaultReference : '',
	t              : '',
	s              : '',
	r              : '',
	q              : '',
	comments       : '',
	location       : {
		description  : '',
		latitude     : null,
		longitude    : null,
		locationsKey : null,
	},
	locationDescription : '',
	files               : [],
} );

export const editAgreement = ( editingAgreement ) => {
	const emptyAgreement = agreements();

	const { file, folder } = editingAgreement;

	return { file, folder, ...trim( emptyAgreement, editingAgreement ) };
};

export const review = () => ( {
	reviewsTypes    : [],
	referenceNumber : '',
	firm            : {
		description : '',
		firmsKey    : '',
	},
	comments     : '',
	dateReceived : '',
	dateDeadline : '',
	dateResponse : '',
	responseBy   : '',
	facilities   : [],
	apn          : '',
	location     : {
		description  : '',
		latitude     : null,
		locationsKey : null,
		longitude    : null,
	},
	locationDescription : '',
	files               : [],
} );

export const editReview = ( editingReview ) => {
	const emptyReview = review();

	const { file, folder } = editingReview;

	return { file, folder, ...trim( emptyReview, editingReview ) };
};

export const permit = () => ( {
	number      : '',
	permitsType : {
		description     : '',
		permitsTypesKey : '',
	},
	jobsKey       : '',
	issuedBy      : '',
	permittee     : '',
	facilitiesKey : '',
	status        : '',
	summary       : '',
	location      : {
		locationsKey : null,
		latitude     : null,
		longitude    : null,
		description  : '',
	},
	locationDescription : '',
	// * wso is going to have to be merged with location in the submission layer * //
	wso                 : '',
	t                   : '',
	r                   : '',
	s                   : '',
	q                   : '',
	dateIssued          : '',
	dateStarted         : '',
	dateFinished        : '',
	dateFinalInspection : '',
	dateDepositReturned : '',
	dateReminder        : '',
	permitFee           : '',
	inspectionFee       : '',
	materialsFee        : '',
	shutdownFee         : '',
	depositFee          : '',
	depositDeductions   : '',
	comments            : '',
	files               : [],
} );

export const editPermit = ( editingPermit ) => {
	const emptyPermit = permit();

	const { file, folder } = editingPermit;

	return { file, folder, ...trim( emptyPermit, editingPermit ) };
};

export const request = () => ( {
	number          : '',
	dateRequested   : '',
	requestingParty : '',
	summary         : '',
	jobsKey         : '',
	rulingAction    : {
		rulingActionsKey : '',
		description      : '',
	},
	facilities       : [],
	fidContributions : '',
	location         : {
		description  : '',
		latitude     : null,
		longitude    : null,
		locationsKey : null,
	},
	locationDescription : '',
	files               : [],
	infoItem            : false,
	comments            : '',
} );

export const editRequest = ( editingRequest ) => {
	const emptyRequest = request();

	const editedRequest = { ...editingRequest	};

	const { file, folder } = editingRequest;

	if ( editingRequest.job ) {
		const { jobsKey } = editingRequest.job;

		editedRequest.jobsKey = jobsKey;
	}

	return { file, folder, ...trim( emptyRequest, editedRequest ) };
};

export default {
	user,
	job,
};
